(function () {
  function parsePHPPrice(text) {
    if (!text) return null;
    const cleaned = text.replace(/[^0-9.,]/g, '').replace(/,/g, '');
    const value = parseFloat(cleaned);
    return isNaN(value) ? null : value;
  }

  async function getBtcPhpRate() {
    const cacheKey = 'btc_php_rate';
    const cacheTimeKey = 'btc_php_rate_time';
    const maxAge = 10 * 60 * 1000;
    const now = Date.now();

    let cachedRate = null;
    let cachedTime = 0;

    try {
      cachedRate = Number(localStorage.getItem(cacheKey) || 0);
      cachedTime = Number(localStorage.getItem(cacheTimeKey) || 0);

      if (cachedRate && cachedTime && (now - cachedTime < maxAge)) {
        return cachedRate;
      }
    } catch (e) {
      console.warn('BTC cache read skipped:', e);
    }

    try {
      const res = await fetch('https://script.google.com/macros/s/AKfycbx_tL9yPWsXdUoGBWbKEfHSslMPOyRIVLSBxmgjqpdxItkCAIkUCTiScAcdZh78OGNt/exec');
      if (!res.ok) throw new Error('BTC rate fetch failed');

      const data = await res.json();
      if (!data || !data.ok) throw new Error('BTC endpoint not ok');

      const rate = Number(data.btc_php);
      if (!rate) throw new Error('Invalid BTC/PHP rate');

      try {
        localStorage.setItem(cacheKey, String(rate));
        localStorage.setItem(cacheTimeKey, String(now));
      } catch (e) {
        console.warn('BTC cache write skipped:', e);
      }

      return rate;
    } catch (e) {
      if (cachedRate) {
        console.warn('BTC fetch failed, using stale local cache:', e);
        return cachedRate;
      }
      throw e;
    }
  }

  function formatBTCAndSats(phpPrice, btcPhp) {
    const btcAmount = phpPrice / btcPhp;
    const satsAmount = Math.round(btcAmount * 100000000);

    return {
      btc: '≈ ' + btcAmount.toFixed(8) + ' BTC',
      sats: satsAmount.toLocaleString() + ' sats ⚡'
    };
  }

  function getMainProductPriceElement() {
    return (
      document.querySelector('.price-item--sale') ||
      document.querySelector('.price-item--regular') ||
      document.querySelector('.price')
    );
  }

  function renderSingleProductPrice(btcPhp) {
    const target = document.querySelector('[data-btc-price]');
    if (!target || !btcPhp) return;

    const priceEl = getMainProductPriceElement();
    if (!priceEl) return;

    const phpPrice = parsePHPPrice(priceEl.textContent);
    if (!phpPrice) return;

    const renderKey = String(phpPrice) + '|' + String(btcPhp);
    if (target.dataset.btcRenderKey === renderKey) return;

    try {
      const result = formatBTCAndSats(phpPrice, btcPhp);

      target.innerHTML =
        '<div style="margin-top:8px;line-height:1.2;">' +
          '<div style="font-size:0.95rem;color:rgba(0,0,0,.78);">' + result.btc + '</div>' +
          '<div style="font-size:0.88rem;color:rgba(0,0,0,.58);margin-top:2px;">≈ ' + result.sats + '</div>' +
        '</div>';

      target.dataset.btcRenderKey = renderKey;
    } catch (e) {
      console.error('Single product BTC render error:', e);
    }
  }

  function renderCardPrices(btcPhp) {
    if (!btcPhp) return;

    const pageIsProduct = document.querySelector('[data-btc-price]');
    let moneyEls;

    if (pageIsProduct) {
      moneyEls = document.querySelectorAll('[data-related-supply-cases] [ref="priceContainer"] .money');
    } else {
      moneyEls = document.querySelectorAll('[ref="priceContainer"] .money');
    }

    if (!moneyEls.length) return;

    for (const moneyEl of moneyEls) {
      if (!moneyEl || moneyEl.dataset.btcProcessed === 'true') continue;

      const phpPrice = parsePHPPrice(moneyEl.textContent);
      if (!phpPrice) continue;

      const priceWrapper = moneyEl.closest('.price, product-price');
      if (!priceWrapper) continue;

      const existingNote = priceWrapper.nextElementSibling;
      if (existingNote && existingNote.classList && existingNote.classList.contains('btc-card-price-note')) {
        moneyEl.dataset.btcProcessed = 'true';
        continue;
      }

      try {
        const result = formatBTCAndSats(phpPrice, btcPhp);

        priceWrapper.style.display = 'none';

        const btcNote = document.createElement('div');
        btcNote.className = 'btc-card-price-note';
        btcNote.style.marginTop = '6px';
        btcNote.style.lineHeight = '1.15';
        btcNote.innerHTML =
          '<div style="font-size:0.9rem;color:rgba(0,0,0,.78);">' + result.sats + '</div>' +
          '<div style="font-size:0.82rem;color:rgba(0,0,0,.58);margin-top:2px;">' + result.btc + '</div>';

        priceWrapper.insertAdjacentElement('afterend', btcNote);
        moneyEl.dataset.btcProcessed = 'true';
      } catch (e) {
        console.error('Card BTC render error:', e);
      }
    }
  }

  function watchProductPriceChanges(btcPhp) {
    const target = document.querySelector('[data-btc-price]');
    if (!target || !btcPhp) return;

    const priceEl = getMainProductPriceElement();
    if (!priceEl) return;

    let lastPriceText = priceEl.textContent.trim();

    const observer = new MutationObserver(function () {
      const currentPriceEl = getMainProductPriceElement();
      if (!currentPriceEl) return;

      const currentPriceText = currentPriceEl.textContent.trim();
      if (currentPriceText === lastPriceText) return;

      lastPriceText = currentPriceText;
      renderSingleProductPrice(btcPhp);
    });

    observer.observe(priceEl, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  async function initBTCDisplay() {
    try {
      const cachedRate = Number(localStorage.getItem('btc_php_rate') || 0);

      if (cachedRate) {
        renderSingleProductPrice(cachedRate);
        renderCardPrices(cachedRate);

        setTimeout(function () {
          renderCardPrices(cachedRate);
        }, 200);

        watchProductPriceChanges(cachedRate);
      }
    } catch (e) {
      console.warn('BTC immediate cache render skipped:', e);
    }

    try {
      const btcPhp = await getBtcPhpRate();
      renderSingleProductPrice(btcPhp);
      renderCardPrices(btcPhp);

      setTimeout(function () {
        renderCardPrices(btcPhp);
      }, 200);

      watchProductPriceChanges(btcPhp);
    } catch (e) {
      console.error('BTC init error:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBTCDisplay);
  } else {
    initBTCDisplay();
  }
})();